import React from 'react';

export const Active = () => {
  return (
    <svg width="64" height="58" viewBox="0 0 64 58" name="active">
      <g id="_2_PT" data-name="2 PT" transform="translate(-2 -7)">
        <path
          id="Path_396"
          data-name="Path 396"
          d="M65.086,20.738H2.914a.916.916,0,0,1-.83-1.3L7.57,7.532A.914.914,0,0,1,8.4,7H59.6a.914.914,0,0,1,.83.532l5.486,11.906a.916.916,0,0,1-.83,1.3ZM4.343,18.906H63.657L59.015,8.832H8.985Z"
          fill="#329926"
        />
        <path
          id="Path_397"
          data-name="Path 397"
          d="M7.364,32.822A5.371,5.371,0,0,1,2,27.458V20.916A.916.916,0,0,1,2.916,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,7.364,32.822ZM3.832,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(0 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_398"
          data-name="Path 398"
          d="M17.078,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,12.63,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,17.078,32.822ZM13.546,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-0.817 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_399"
          data-name="Path 399"
          d="M26.793,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,22.345,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM23.261,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(-1.672 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_400"
          data-name="Path 400"
          d="M36.507,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,32.059,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,36.507,32.822ZM32.975,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-2.507 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_401"
          data-name="Path 401"
          d="M46.221,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,41.773,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM42.689,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-3.343 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_402"
          data-name="Path 402"
          d="M55.936,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,51.488,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM52.4,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-4.197 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_403"
          data-name="Path 403"
          d="M65.65,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,61.2,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,65.65,32.822ZM62.118,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(-5.015 -1.014)"
          fill="#329926"
        />
        <path
          id="Path_404"
          data-name="Path 404"
          d="M62.583,66.8H5.824a.915.915,0,0,1-.914-.916V32H6.738V64.972H61.669V32H63.5V65.887A.915.915,0,0,1,62.583,66.8Z"
          transform="translate(-0.245 -1.803)"
          fill="#329926"
        />
        <path
          id="Path_405"
          data-name="Path 405"
          d="M58.486,67.476H42.916A.916.916,0,0,1,42,66.56V40.916A.916.916,0,0,1,42.916,40h15.57a.916.916,0,0,1,.916.916V66.56A.916.916,0,0,1,58.486,67.476ZM43.832,65.645H57.57V41.832H43.832Z"
          transform="translate(-3.452 -2.476)"
          fill="#329926"
        />
        <path
          id="Path_406"
          data-name="Path 406"
          d="M34.813,59.649h-22.9A.916.916,0,0,1,11,58.733V40.416a.916.916,0,0,1,.916-.916h22.9a.916.916,0,0,1,.916.916V58.733A.916.916,0,0,1,34.813,59.649ZM12.832,57.818H33.9V41.332H12.832Z"
          transform="translate(-0.757 -2.434)"
          fill="#329926"
        />
      </g>
    </svg>
  );
};
export const Inactive = () => {
  return (
    <svg width="64" height="58" viewBox="0 0 64 58" name="inactive">
      <g id="_2_PT" data-name="2 PT" transform="translate(-2 -7)">
        <path
          id="Path_396"
          data-name="Path 396"
          d="M65.086,20.738H2.914a.916.916,0,0,1-.83-1.3L7.57,7.532A.914.914,0,0,1,8.4,7H59.6a.914.914,0,0,1,.83.532l5.486,11.906a.916.916,0,0,1-.83,1.3ZM4.343,18.906H63.657L59.015,8.832H8.985Z"
          fill="#ee2b48"
        />
        <path
          id="Path_397"
          data-name="Path 397"
          d="M7.364,32.822A5.371,5.371,0,0,1,2,27.458V20.916A.916.916,0,0,1,2.916,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,7.364,32.822ZM3.832,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(0 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_398"
          data-name="Path 398"
          d="M17.078,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,12.63,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,17.078,32.822ZM13.546,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-0.817 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_399"
          data-name="Path 399"
          d="M26.793,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,22.345,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM23.261,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(-1.672 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_400"
          data-name="Path 400"
          d="M36.507,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,32.059,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,36.507,32.822ZM32.975,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-2.507 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_401"
          data-name="Path 401"
          d="M46.221,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,41.773,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM42.689,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-3.343 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_402"
          data-name="Path 402"
          d="M55.936,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,51.488,20h8.9a.916.916,0,0,1,.916.916v6.542a5.371,5.371,0,0,1-5.364,5.364ZM52.4,21.832v5.626a3.533,3.533,0,1,0,7.065,0V21.832Z"
          transform="translate(-4.197 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_403"
          data-name="Path 403"
          d="M65.65,32.822a5.371,5.371,0,0,1-5.364-5.364V20.916A.916.916,0,0,1,61.2,20h8.9a.916.916,0,0,1,.916.916v6.542A5.371,5.371,0,0,1,65.65,32.822ZM62.118,21.832v5.626a3.533,3.533,0,0,0,7.065,0V21.832Z"
          transform="translate(-5.015 -1.014)"
          fill="#ee2b48"
        />
        <path
          id="Path_404"
          data-name="Path 404"
          d="M62.583,66.8H5.824a.915.915,0,0,1-.914-.916V32H6.738V64.972H61.669V32H63.5V65.887A.915.915,0,0,1,62.583,66.8Z"
          transform="translate(-0.245 -1.803)"
          fill="#ee2b48"
        />
        <path
          id="Path_405"
          data-name="Path 405"
          d="M58.486,67.476H42.916A.916.916,0,0,1,42,66.56V40.916A.916.916,0,0,1,42.916,40h15.57a.916.916,0,0,1,.916.916V66.56A.916.916,0,0,1,58.486,67.476ZM43.832,65.645H57.57V41.832H43.832Z"
          transform="translate(-3.452 -2.476)"
          fill="#ee2b48"
        />
        <path
          id="Path_406"
          data-name="Path 406"
          d="M34.813,59.649h-22.9A.916.916,0,0,1,11,58.733V40.416a.916.916,0,0,1,.916-.916h22.9a.916.916,0,0,1,.916.916V58.733A.916.916,0,0,1,34.813,59.649ZM12.832,57.818H33.9V41.332H12.832Z"
          transform="translate(-0.757 -2.434)"
          fill="#ee2b48"
        />
      </g>
    </svg>
  );
};
